"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getExternalEndpoint = exports.getEndpoint = void 0;
function getEndpoint(session, request, profileId, path) {
    let route = path;
    switch (request.method) {
        case "GET":
        case "PUT":
        case "DELETE":
            if (request.body && typeof request.body.uuid === "string") {
                route = `${path}/${request.body.uuid}`;
            }
            break;
        case "POST":
            route = `profiles/${profileId}/${path}`;
            break;
        default:
            throw new Error("NO METHOD");
    }
    return `${session.baseUrl}/${route}`;
}
exports.getEndpoint = getEndpoint;
function getExternalEndpoint(session, request, path) {
    let route = path;
    switch (request.method) {
        case "GET":
        case "PUT":
        case "DELETE":
            if (request.body && typeof request.body.uuid === "string") {
                route = `${path}/${request.body.uuid}`;
            }
            break;
        case "POST":
            break;
        default:
            throw new Error("NO METHOD");
    }
    return `${session.baseUrl}/${route}`;
}
exports.getExternalEndpoint = getExternalEndpoint;
//# sourceMappingURL=ProfileRequestUtils.js.map